import { message } from 'antd';
import { api } from '../fetch/bussiness/api';
import { HttpStatusCode } from '../fetch/core/constant';
import { buildURL } from '../fetch/core/util';
import { actionSendHttpRequest } from '../redux/action';
import {
  actionCheckQrCode,
  actionLogOut,
  actionReloadCookie,
} from '../redux/action/login';
import { getCookie } from './cookie';
import $ from 'jquery';
let timeCode: any = null;
export const trainCodeStatus = () => {
  if (timeCode) return;
  timeCode = setInterval(() => {
    checkQrcode();
  }, 1000);
};

export const clearCheckQrcodeInterval = () => {
  timeCode && clearInterval(timeCode);
};
/*
 定时轮询二维码是否被app扫描
*/
export const checkQrcode = () => {
  const url = buildURL({
    absoluteURL: `https://qr.jdl.cn/check`,
    urlParams: {
      appid: '1673',
      callback: 'handleCallback',
      token: getCookie('wlfstk_smdl'),
      _: new Date().getTime(),
    },
  });
  $.ajax({
    url: url,
    dataType: 'jsonp',
    headers: {
      QRCodeKey: getCookie('QRCodeKey'),
    },
  });
};

/*
  轮询二维码回调函数
  二维码状态：
  code: 200 授权登录
  code: 201 "二维码未扫描，请扫描二维码"
  code: 202 "请手机客户端确认登录"
  code: 203 '二维码无效'
  code: 205  '二维码已取消授权'
*/
(window as any).handleCallback = (resp: any) => {
  if ((window as any).store.getState().login.loginWay !== 'passport') {
    clearInterval(timeCode);
    timeCode = null;
    return;
  }
  (window as any).store.dispatch(actionCheckQrCode({ response: resp }));
  if (resp.code == 200) {
    clearInterval(timeCode);
    timeCode = null;

    //  请求passport写登录态cookie的地址
    const url = 'https://ssa.jdl.cn/sso/redirect';
    const baseURL = location.protocol + '//' + process.env.JDX_APP_JDX_MONITOR;
    const encodeUrl = encodeURIComponent(encodeURIComponent(baseURL));
    document.cookie = `BakReturnUrl=${encodeUrl}; path=/; domain=.jdl.cn`;
    const buildPassportUrl = buildURL({
      absoluteURL:
        'https://passport.jd.com/uc/qrCodeTicketValidation?sso=1&source=jdxmonitor_pc',
      urlParams: {
        t: resp.ticket,
        ReturnUrl: url,
        callback: 'callback',
      },
    });
    $.ajax({
      url: buildPassportUrl,
      dataType: 'jsonp',
      header: {
        QRCodeKey: getCookie('QRCodeKey'),
      },
    });
  }
};

/**
 * setCookie 将thor从jd.com写到jdl.cn
 * @param {any} resp
 */
(window as any).callback = (resp: any) => {
  (window as any).store.dispatch(actionReloadCookie());
  localStorage.setItem('reload', 'true');
  window.location.href = resp.url;
};

// 退出登录
export const passportExit = () => {
  localStorage.setItem('reload', 'false');
  document.cookie = `ReturnUrl=0; path=/; domain=.jdl.cn expires=${new Date(
    0,
  ).toUTCString()}`;
  // 退出集团passport登录
  $.ajax({
    url: 'https://ssa.jdl.cn/exit',
    dataType: 'jsonp',
    success: (resp: any) => {
      const response = JSON.parse(resp);
      if (response.result === 'success') {
        window.location.replace('/login');
        localStorage.removeItem('ENUM_LIST_MAP');
        (window as any).store.dispatch(actionLogOut());
      }
    },
  });
};
